import {Component, ViewChild} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {AbstractControl} from '@angular/forms';

@Component({
  selector: 'formly-textarea-type',
  styleUrls: ['./text-area.component.scss'],
  templateUrl: './text-area.component.html'
})
export class TextAreaComponent extends FieldType {
  @ViewChild('#formTextArea') formFieldControl: AbstractControl;

  defaultOptions = {
    defaultValue: '',
  };
}

